import https from 'https'
import axios from 'axios'
import qs from 'qs'
import { isEmpty, isNil } from 'ramda'
import { API_VERSION, API_PATH_PREFIX_BY_API_VERSION } from 'enums/api'

const agent = new https.Agent({
  rejectUnauthorized: false
})

const paramsSerializer = params =>
  qs.stringify(params, {
    filter: (key, val) => {
      if (isNil(val) || isEmpty(val)) return undefined

      return val instanceof Date ? +val : val
    },
    arrayFormat: 'repeat'
  })

export default function({ $axios, req, app, redirect, store }, inject) {
  const generateRequestInterceptorHandlerBase = (apiUrl, apiUrlInternal) => {
    return function(config) {
      config.baseURL = process.client ? apiUrl : apiUrlInternal || apiUrl

      return config
    }
  }

  const generateRequestInterceptorHandler = (apiUrl, apiUrlInternal) => {
    return function(config) {
      const accessToken = store.getters['auth/accessToken']

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return generateRequestInterceptorHandlerBase(
        apiUrl,
        apiUrlInternal
      )(config)
    }
  }

  $axios.setHeader('Accept-Language', 'en-US')
  $axios.defaults.httpsAgent = agent
  $axios.defaults.paramsSerializer = paramsSerializer

  const apiV1PathPrefix = API_PATH_PREFIX_BY_API_VERSION[API_VERSION.V1]
  const apiV2PathPrefix = API_PATH_PREFIX_BY_API_VERSION[API_VERSION.V2]

  $axios.interceptors.request.use(
    generateRequestInterceptorHandler(app.$env.FM_API_URL)
  )

  const fmAxios = axios.create({
    headers: {
      'Accept-Language': 'en-US'
    },
    httpsAgent: agent
  })

  fmAxios.defaults.paramsSerializer = paramsSerializer

  fmAxios.interceptors.request.use(
    generateRequestInterceptorHandlerBase(
      `${app.$env.FM_API_URL}/${apiV1PathPrefix}`,
      `${app.$env.FM_API_URL}/${apiV1PathPrefix}`
    )
  )

  const fmAxiosV2 = axios.create({
    headers: {
      'Accept-Language': 'en-US'
    },
    httpsAgent: agent
  })

  fmAxiosV2.defaults.paramsSerializer = paramsSerializer

  fmAxiosV2.interceptors.request.use(
    generateRequestInterceptorHandlerBase(
      `${app.$env.FM_API_URL}/${apiV2PathPrefix}`,
      `${app.$env.FM_API_URL}/${apiV2PathPrefix}`
    )
  )

  inject('fmAxios', fmAxios)
  inject('fmAxiosV2', fmAxiosV2)
}
